module.exports = __webpack_public_path__ + "img/16.3f517859.png";